import React from 'react';
import { Form } from '../../../../../components';
import { NameField, VSphereVersionField } from '../../cloudAccountFields';
import TagsSelector from '../../../../TagsSelector';
import { isVSphere, isHyperV } from '../../../../../constants';

/**
 * Downloadable Cloud Account - Edit Mode
 * Focused component for editing downloadable cloud accounts
 * (vSphere, OpenShift, OpenStack, NC2, HPE VME, Hyper-V)
 */
export const DownloadableCloudAccountEdit = ({
    cloudType,
    formData,
    errors,
    onChange,
    tags,
    onTagsChange,
    userOrg,
}) => {
    return (
        <>
            {/* vSphere Version - only for vSphere */}
            {isVSphere(cloudType) && (
                <VSphereVersionField
                    value={formData.vsphere_version}
                    onChange={onChange('vsphere_version')}
                    error={errors.vsphere_version}
                />
            )}

            <NameField
                value={formData.name}
                onChange={onChange('name')}
                error={errors.name}
                extra={
                    isHyperV(cloudType)
                        ? 'Only alphanumerics, periods, spaces, dashes and underscores are allowed.'
                        : undefined
                }
            />

            {/* Tags */}
            <Form.Item label="Tags">
                <TagsSelector value={tags} onChange={onTagsChange} userOrg={userOrg} />
            </Form.Item>
        </>
    );
};
